import { render, staticRenderFns } from "./Geral.vue?vue&type=template&id=46659c68&"
import script from "./Geral.vue?vue&type=script&lang=js&"
export * from "./Geral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports